import { Form, message } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import {
  GET_ORDER_PAYMENT_DETAIL,
  OrderPaymentDetialRes,
} from '../../api/paymentOrder'
import { isResponseCodeSuccess } from '../../tools/util'
import { useQuery } from '../../tools/utilHooks'
import { orderStateEnum } from '../../global/enums'
import { paymentStatusEnum } from '@/global/enum/invoice'

const useHook = () => {
  const [detailInfo, setDetailInfo] = useState<OrderPaymentDetialRes | null>(
    null,
  )
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const erpTotalPrice = useMemo(
    () =>
      (detailInfo?.paymentList ?? [])
        .map((item) => item.price)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [detailInfo],
  )

  const convertDetailState = (
    detail: OrderPaymentDetialRes,
  ): OrderPaymentDetialRes => {
    return {
      ...detail,
      paymentStatus:
        paymentStatusEnum.getLabelByValue(detail?.paymentStatus as any) ?? '',
      orderInfoList: detail.orderInfoList.map((item) => ({
        ...item,
        orderState:
          orderStateEnum.getLabelByValue(item?.orderState as any) ?? '',
      })),
    }
  }

  const getDetailInfo = async () => {
    const res = await GET_ORDER_PAYMENT_DETAIL({
      paymentId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = convertDetailState(res.data)
      setDetailInfo(resData)
      form.setFieldsValue({
        ...res.data,
      })
    } else {
      message.warning(res.msg)
    }
  }

  useEffect(() => {
    if (id) {
      getDetailInfo()
    }
    // eslint-disable-next-line
  }, [])

  return {
    form,
    detailInfo,
    erpTotalPrice,
  }
}
export default useHook
import { Form, message } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import {
  GET_ORDER_PAYMENT_DETAIL,
  OrderPaymentDetialRes,
} from '../../api/paymentOrder'
import { isResponseCodeSuccess } from '../../tools/util'
import { useQuery } from '../../tools/utilHooks'
import { orderStateEnum } from '../../global/enums'
import { paymentStatusEnum } from '@/global/enum/invoice'

const useHook = () => {
  const [detailInfo, setDetailInfo] = useState<OrderPaymentDetialRes | null>(
    null,
  )
  const query = useQuery()
  const id = query.get('id') || ''
  const [form] = Form.useForm()
  const erpTotalPrice = useMemo(
    () =>
      (detailInfo?.paymentList ?? [])
        .map((item) => item.price)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [detailInfo],
  )

  const convertDetailState = (
    detail: OrderPaymentDetialRes,
  ): OrderPaymentDetialRes => {
    return {
      ...detail,
      paymentStatus:
        paymentStatusEnum.getLabelByValue(detail?.paymentStatus as any) ?? '',
      orderInfoList: detail.orderInfoList.map((item) => ({
        ...item,
        orderState:
          orderStateEnum.getLabelByValue(item?.orderState as any) ?? '',
      })),
    }
  }

  const getDetailInfo = async () => {
    const res = await GET_ORDER_PAYMENT_DETAIL({
      paymentId: id,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = convertDetailState(res.data)
      setDetailInfo(resData)
      form.setFieldsValue({
        ...res.data,
      })
    } else {
      message.warning(res.msg)
    }
  }

  useEffect(() => {
    if (id) {
      getDetailInfo()
    }
    // eslint-disable-next-line
  }, [])

  return {
    form,
    detailInfo,
    erpTotalPrice,
  }
}
export default useHook
